module.exports = __webpack_public_path__ + "img/ls.fac1d814.svg";